import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Wallet } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

const FELT = [
  ["aar", "År satsane gjeld for"],
  ["sifo_einsleg", "SIFO: einsleg vaksen (kr/md)"],
  ["sifo_par", "SIFO: par (kr/md)"],
  ["sifo_barn", "SIFO: barn (kr/md)"],
  ["statleg_einsleg", "Statleg sats: einsleg (kr/md)"],
  ["statleg_par", "Statleg sats: ektepar/sambuarar (kr/md)"],
  ["statleg_barn_0_5", "Statleg sats: barn 0–5 år (kr/md)"],
  ["statleg_barn_6_10", "Statleg sats: barn 6–10 år (kr/md)"],
  ["statleg_barn_11_17", "Statleg sats: barn 11–17 år (kr/md)"],
];
const TEKSTFELT = ["sifo_kjelde", "statleg_kjelde"];

export const SatsarCard = () => {
  const [satsar, setSatsar] = useState(null);
  const [lagrar, setLagrar] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/satsar`).then((r) => setSatsar(r.data)).catch(() => setSatsar(null));
  }, []);

  const lagre = async () => {
    setLagrar(true);
    try {
      const data = Object.fromEntries(
        Object.entries(satsar)
          .filter(([k]) => FELT.some(([f]) => f === k) || TEKSTFELT.includes(k))
          .map(([k, v]) => [k, TEKSTFELT.includes(k) ? v : v === "" || v == null ? null : Number(v)])
      );
      const res = await axios.put(`${API}/api/admin/satsar`, data, { withCredentials: true });
      setSatsar(res.data);
      toast.success(`Satsane for ${data.aar} er lagra`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Klarte ikkje lagre satsane");
    }
    setLagrar(false);
  };

  if (!satsar) return null;
  return (
    <Card className="bg-white border border-[#E6E9F0]" data-testid="satsar-card">
      <CardHeader>
        <CardTitle className="text-base font-medium text-[#1F2A36] flex items-center gap-2">
          <Wallet className="w-4 h-4 text-[#103766]" /> Satsar for livsopphald
        </CardTitle>
        <p className="text-sm text-[#4B647F]">
          SIFOs referansebudsjett og dei statlege rettleiande satsane som kommunetala blir målte mot. Oppdater dei når nye satsar kjem – då gjeld
          dei for heile appen.
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid sm:grid-cols-3 gap-3">
          {FELT.map(([felt, label]) => (
            <div key={felt}>
              <label className="text-xs text-[#8AA4BF]">{label}</label>
              <Input
                type="number"
                value={satsar[felt] ?? ""}
                onChange={(e) => setSatsar({ ...satsar, [felt]: e.target.value })}
                className="mt-1"
                data-testid={`satsar-${felt}`}
              />
            </div>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          {TEKSTFELT.map((felt) => (
            <div key={felt}>
              <label className="text-xs text-[#8AA4BF]">{felt === "sifo_kjelde" ? "Kjelde SIFO" : "Kjelde statleg sats"}</label>
              <Input
                value={satsar[felt] ?? ""}
                onChange={(e) => setSatsar({ ...satsar, [felt]: e.target.value })}
                className="mt-1"
                data-testid={`satsar-${felt}`}
              />
            </div>
          ))}
        </div>
        <Button onClick={lagre} disabled={lagrar} className="bg-[#E52437] hover:bg-[#c41d2d]" data-testid="satsar-lagre">
          {lagrar ? "Lagrar …" : "Lagre satsane"}
        </Button>
      </CardContent>
    </Card>
  );
};

export default SatsarCard;
